<template>
  <div v-loading="loading">

    <health-widget icon="Conclusion"
                   title="Заключение"
                   subtitle="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ornare sit."
                   class="health-widget"/>


    <template v-if="conclusion && Object.keys(conclusion).length !== 0">
      <attention-zones/>
      <food/>
      <activities/>
      <other/>
    </template>

    <el-alert
        v-else
        v-loading="loading"
        :closable="false"
        title="Заключение не сформулировано, пожалуйта вернитесь на вкладку «Приборы» и сформулируйте общее заключение внизу страницы."
        style="margin-top: 10px; max-width: 650px;"
        type="info">
    </el-alert>

  </div>
</template>

<script>
import AttentionZones from "@/components/visit/conclusion/AttentionZones"
import Food from "@/components/visit/conclusion/Food"
import Activities from "@/components/visit/conclusion/Activities"
import Other from "@/components/visit/conclusion/Other"
import {mapGetters} from "vuex";
import HealthWidget from "@/components/elements/HealthWidget.vue"

export default {
  name: "Conclusion",
  components: {
    AttentionZones,
    Food,
    Activities,
    Other,
    HealthWidget
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters("visit", {
          conclusion: "conclusion",
          loading: "loading",
        }
    ),
  },
  methods: {
    next() {

    }
  }
}
</script>
<style lang="scss" scoped>
.subtitle {
  margin-top: 12px;

  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  color: #111;
}

</style>